export class TemplateMedicineTypeRequest{
    public medicineTypeName: string;
    public medicineTypeDescription: string;
    public idTemplate: number;
}